import React, { useState } from 'react';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: (token: string) => void;
}

export default function UserAuthModal({ isOpen, onClose, onSuccess }: Props) {
    const [mode, setMode] = useState<'login' | 'register'>('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch(`/api/user/auth/${mode}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(
                    mode === 'register'
                        ? { firstName, lastName, email, password }
                        : { email, password }
                ),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Fehler');

            localStorage.setItem('userToken', data.token);
            onSuccess(data.token);
            onClose();
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded shadow-lg w-full max-w-md text-black">
                <h2 className="text-xl font-bold mb-4">
                    {mode === 'login' ? 'Login' : 'Konto erstellen'}
                </h2>
                <form onSubmit={handleSubmit} className="space-y-3">
                    {mode === 'register' && (
                        <>
                            <input placeholder="Vorname" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full border px-3 py-2" />
                            <input placeholder="Nachname" value={lastName} onChange={e => setLastName(e.target.value)} className="w-full border px-3 py-2" />
                        </>
                    )}
                    <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} className="w-full border px-3 py-2" />
                    <input type="password" placeholder="Passwort" value={password} onChange={e => setPassword(e.target.value)} className="w-full border px-3 py-2" />
                    {error && <div className="text-red-600 text-sm">{error}</div>}
                    <button type="submit" className="bg-blue-600 text-white px-4 py-2 w-full">
                        {mode === 'login' ? 'Einloggen' : 'Registrieren'}
                    </button>
                </form>
                <div className="mt-4 text-sm text-center">
                    {mode === 'login' ? (
                        <>
                            Noch kein Konto?{' '}
                            <button onClick={() => setMode('register')} className="text-blue-600 underline">
                                Jetzt registrieren
                            </button>
                        </>
                    ) : (
                        <>
                            Bereits ein Konto?{' '}
                            <button onClick={() => setMode('login')} className="text-blue-600 underline">
                                Einloggen
                            </button>
                        </>
                    )}
                </div>
                <button onClick={onClose} className="absolute top-2 right-4 text-gray-500 text-xl">&times;</button>
            </div>
        </div>
    );
}
